import React, {useEffect, Fragment} from 'react';
import PropTypes from 'prop-types';
import {compose} from "recompose";
import {connect} from "react-redux";
import {bindActionCreators} from 'redux';
import ActionCreator from "../../../store/actions/index";
import {Marker, Tooltip} from "react-leaflet";
import Leaflet from "leaflet";
import t from "../../../languages/pl";
import withFilters from '../../HOC/withFilters';
import CarMapIcon from './CarMapIcon';

const drawMarkers = (cars, callback) => {
    if (!Array.isArray(cars))
        cars = [cars];
    return cars.map(marker => {
        if (!marker.pozycja_gps)
            return false;
        return (
            <Marker
                key={marker.auto_id}
                icon={CarMapIcon(marker.typ, marker.rejestracja, marker.kierowca)}
                position={marker.pozycja_gps}
                onClick={callback.bind(this, marker.auto_id)}>
                <Tooltip
                    direction="top"
                    offset={new Leaflet.point(25, 0)}
                    className="toyotaFont"
                >
                    {t.registrationNo}: {marker.rejestracja}
                    <br/>
                    {t.car}: {marker.marka} {marker.model}
                    <br/>
                    {t.driver}: {marker.kierowca}
                    <br />
                    {marker.opis}
                </Tooltip>
            </Marker>
        );
    });
};

const Markers = props => {
    const {cars = [], selectedCar, showCurrentRoute} = props;

    useEffect(() => {
        props.trackAllCars();
    }, []);

    const handleMarkerClick = (id) => {
        let car = cars.find(car => car.auto_id === id);
        if (car != null && !showCurrentRoute) {
            props.setSelectedCar(car);
            props.resetToDefaults();
        }
    };

    return (
        <Fragment>
            {drawMarkers(selectedCar ? selectedCar : cars, handleMarkerClick)}
        </Fragment>
    );
};

const mapStateToProps = state => {
    return {
        selectedCar: state.mapCarsReducer.selectedCar,
        cars: state.mapCarsReducer.cars,
        showCurrentRoute: state.mapRoutesReducer.showCurrentRoute,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
)(withFilters(Markers, true, true));

Markers.propTypes = {
    cars: PropTypes.array,
    selectedCar: PropTypes.object,
    trackAllCars: PropTypes.func,
    setSelectedCar: PropTypes.func,
    resetToDefaults: PropTypes.func,
    showCurrentRoute: PropTypes.bool,
}
;
